import { type AxiosError } from 'axios'

import { NOT_ACCEPTABLE } from 'shared/consts/codes'

import BackendError from './BackendError'

class NotAcceptableError extends BackendError {
  status: number

  constructor(message: AxiosError) {
    super(message)
    // Ensure the name of this error is the same as the class name
    this.name = this.constructor.name
    this.status = NOT_ACCEPTABLE

    // This clips the constructor invocation from the stack trace.
    // It's not absolutely essential, but it does make the stack trace a little nicer.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/captureStackTrace#installing_stack_trace_on_a_custom_error_object
    Error.captureStackTrace(this, this.constructor)
  }
}

export default NotAcceptableError
